<template lang="pug" src="./templates/ProductCategoryPage.pug"></template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { ContentLoader } from 'vue-content-loader';
import matchHeight from 'jquery-match-height';
import VueSlider from 'vue-slider-component';
import EventBus from "../../../eventBus";
import router from '../../../routes';
import BreadcrumbsManager from '../../../mixins/BreadcrumbsManager';
import PageHeader from '../../../components/layouts/PageHeader.vue';
import ProductListItem from '../../../components/product/ProductListItem.vue';
import ProductFilters from "./ProductFilters";
import { RepositoryFactory } from '../../../repositoryFactory';
import 'swiper/css/swiper.css';
import 'vue-slider-component/theme/antd.css';
import TitleManager from '../../../mixins/TitleManager';
import ProductCategorySpecs from "./ProductCategorySpecs";
import ProductResponsiveFilters from "../../../components/product/ProductResponsiveFilters";
import ProductListTable from "../../../components/product/ProductListTable";
import CompareBar from "../../../components/compare/CompareBar";
import MobileDetect from 'mobile-detect';

const ProductRepository = RepositoryFactory.get('product');
const BrandRepository = RepositoryFactory.get('brand');
const ProductCategoryRepository = RepositoryFactory.get('productCategory');

window.matchHeight = matchHeight;
const md = new MobileDetect(window.navigator.userAgent);

export default {
  components: {
    ContentLoader,
    CompareBar,
    PageHeader,
    ProductListItem,
    ProductFilters,
    ProductListTable,
    Swiper,
    SwiperSlide,
    VueSlider,
    ProductResponsiveFilters,
  },
  directives: {
    swiper: directive,
  },
  mixins: [BreadcrumbsManager, TitleManager],
  data() {
    return {
      loading: {
        isFetching: false,
      },
      swiperCategoryOptions: {
        speed: 400,
        spaceBetween: 0,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.product-subcat-filter__button--next',
          prevEl: '.product-subcat-filter__button--prev',
        },
        breakpoints: {
          1024: {
            slidesPerView: 'auto',
            spaceBetween: 0,
          },
        },
      },
      swiperBrandOptions: {
        speed: 400,
        spaceBetween: 12,
        slidesPerView: 3,
        slidesPerGroup: 3,
        navigation: {
          nextEl: '.product-brand-filter__button--next',
          prevEl: '.product-brand-filter__button--prev',
        },
        breakpoints: {
          1024: {
            slidesPerView: 'auto',
            spaceBetween: 10,
          },
        },
      },
      category: {},
      brands: [],
      products: [],
      filters: {
        sort: '',
        subCategory: false,
        brand: false,
        models: [],
        series: [],
        variants: {},
        // price: [380, 600],
      },
      options: {
        layout: md.mobile() ? 'grid' : 'table',
        filters: {},
      },
      config: {
        table: {
          columns: []
        }
      }
    };
  },
  metaInfo() {
    return {
      title: this.$store.state.title.title,
    };
  },
  computed: {
    filteredBrandList() {
      if (this.options.filters.brands) {
        const query = this.options.filters.brands.query ?? '';
        return this.options.filters.brands.options.filter((brand) => brand.name.toLowerCase().includes(query.toLowerCase()));
      }
      return [];
    },
    filteredSerieList() {
      if (this.options.filters.series) {
        const query = this.options.filters.series.query ?? '';
        return this.options.filters.series.options.filter((serie) => serie.name.toLowerCase().includes(query.toLowerCase()));
      }
      return [];
    },
  },
  watch: {
    $route(val, oldVal) {
      if (
        (val.params.subCategory !== oldVal.params.subCategory)
        || (val.params.slug !== oldVal.params.slug)
        || (val.params.brand !== oldVal.params.brand)
      ) {
        this.products = [];

        this.filters = {
          ...this.filters,
          ...{
            slug: val.params.slug,
            category: val.params.slug ?? false,
            subCategory: val.params.subCategory ?? false,
            brand: val.params.brand ?? false,
            models: [],
            series: [],
            variants: {},
            scopes: false,
          },
        };
        this.options = { ...this.options, ...{ filters: {}, pagination: {} } };
      }

      this.getProductCategory();
      this.refreshTitle();
      this.getProducts({
        category: val.params.slug,
        subCategory: val.params.subCategory,
        brand: val.params.brand,
        page: val.params.page ?? 1,
      });

      EventBus.$emit('FILTERS_UPDATED', this.filters);
    },
  },
  created() {
    const { params } = this.$route;
    this.filters.category = params.slug ?? false;
    this.filters.subCategory = params.subCategory ?? false;
    this.filters.brand = params.brand ?? false;
    this.filters.page = params.page ?? 1;
  },
  mounted() {
    EventBus.$emit('FILTERS_UPDATED', this.filters);

    EventBus.$on('FILTERS_SELECTED', payLoad => {
      this.onFiltersUpdated(payLoad);
    });

    this.getProductCategory();
    this.getProducts();
    this.refreshTitle();

    this.$watch('filters.sort', () => {
      this.getProducts();
    });

    this.$watch('filters.page', () => {
      this.getProducts();
    });

    this.$watch('filters.brand', (val, oldVal) => {
      if (val === oldVal) return;
      this.filters.models = [];
      this.filters.series = [];
    });
  },
  methods: {
    async refreshTitle() {
      const { name, params } = this.$route;
      let brand = {}; let subCategory = {}; let category = {};
      if (typeof params.brand !== 'undefined') {
        const { data } = await BrandRepository.getBySlug(params.brand);
        brand = data;
      }
      if (typeof params.subCategory !== 'undefined') {
        const { data } = await ProductCategoryRepository.getBySlug(params.subCategory).then((resp) => resp.data);
        subCategory = data;
      }
      if (typeof params.slug !== 'undefined') {
        const { data } = await ProductCategoryRepository.getBySlug(params.slug).then((resp) => resp.data);
        category = data;
      }
      if (name === 'shop.category') {
        this.setTitle(`${category.name}`);
      }
      if (name === 'shop.category.brand') {
        this.setTitle(`${category.name} ${brand.name}`);
      }
      if (name === 'shop.category.subcategory.brand') {
        this.setTitle(`${subCategory.name} ${brand.name}`);
      }
    },
    async getProductCategory() {
      const { data } = await ProductCategoryRepository.getBySlug(this.$route.params.slug)
        .then((resp) => resp.data);
      this.category = data;

      const breadCrumbs = [
        { name: this.category.name, to: { path: '/shop/' + this.category.slug } },
      ];

      if (this.$route.name === 'shop.category.subcategory') {
        const subCategory = await ProductCategoryRepository.getBySlug(this.$route.params.subCategory).then(resp => resp.data);
        breadCrumbs.push({ name: subCategory.data.name })
      }

      const columns = _.map(data.filters, 'name');
      this.config = { ...this.config, ...{ table: { ...this.config.table, columns } } }

      this.setBreadcrumbs(breadCrumbs);
    },
    async getProducts(filters = {}) {
      this.loading = { ...this.loading, ...{ isFetching: true } };
      this.products = [];
      const response = await ProductRepository.get({
        category: this.$route.params.slug,
        subCategory: this.$route.params.subCategory,
        brand: this.$route.params.brand,
        ...this.filters,
        ...filters,
      }).then((resp) => resp.data);
      this.products = response.data;
      this.options = {
        ...this.options,
        ...{
          pagination: response.meta,
        },
      };
      this.options = { ...this.options, ...{ filters: response.filters } };

      // this.options = { ...this.options, ...{ priceSlider: { min: parseInt(filters.price.min, 10), max: parseInt(filters.price.max, 10) } } };

      Vue.nextTick(() => {
        $('.product-list__item').matchHeight();
      });
      this.loading = { ...this.loading, ...{ isFetching: false } };
    },
    isSubCategorySelected(category) {
      const { slug } = category;
      return this.$route.params.subCategory === slug;
    },
    onSubCategorySelected(category) {
      const { slug } = category;
      if (this.$route.params.brand) {
        router.push(`/shop/${this.category.slug}/${slug}/${this.$route.params.brand}`);
      } else {
        router.push(`/shop/${this.category.slug}/${slug}`);
      }
    },
    onPageChange(page) {
      this.filters = {
        ...this.filters,
        ...{
          category: this.$route.params.slug,
          subCategory: this.$route.params.subCategory,
          brand: this.$route.params.brand,
          page,
        },
      };
      const { name } = this.$route;
      if (name === 'shop.category') {
        router.push({
          name: 'shop.category',
          params: { slug: this.$route.params.slug, page },
        });
      }
      if (name === 'shop.category.brand') {
        router.push({
          name: 'shop.category.brand',
          params: { slug: this.$route.params.slug, page, brand: this.$route.params.brand },
        });
      }
      if (name === 'shop.category.subcategory.brand') {
        router.push({
          name: 'shop.category.subcategory.brand',
          params: {
            slug: this.$route.params.slug, page, brand: this.$route.params.brand, subCategory: this.$route.params.subCategory,
          },
        });
      }
      window.scrollTo(0, 0);
    },
    changeLayout(layout) {
      this.options = { ...this.options, ...{ layout } };

      Vue.nextTick(() => {
        $('.product-list__item').matchHeight();
      });
    },
    onFiltersUpdated(filters) {
      console.log('filters updated');
      this.filters = { ...this.filters, ...filters }
      this.getProducts();
    },
    onTableSorted(sortData) {
      const sortString = `${sortData.column}:${sortData.direction}`;
      this.filters = {
        ...this.filters,
        ...{
          sort: sortString
        }
      }
    },
    onSubCategoryClear() {
      router.push(`/shop/${this.category.slug}`);
    }
  },
};
</script>
